import React from "react"
import { IIconProps } from "./Icon/Interfaces"

const CopyIcon = ({ width = 15, height = 15, strokeColor = "var(--blue)" }: IIconProps) => {
	return (
		<>
			<svg
				height={height}
				width={width}
				viewBox="0 0 13 16"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
			>
				<path
					d="M2 2C2 1.46957 2.21071 0.960859 2.58579 0.585786C2.96086 0.210714 3.46957 0 4 0H7.586C7.98369 0.000350104 8.36497 0.158615 8.646 0.44L12.561 4.354C12.842 4.6352 12.9999 5.01645 13 5.414V12C13 12.5304 12.7893 13.0391 12.4142 13.4142C12.0391 13.7893 11.5304 14 11 14H4C3.46957 14 2.96086 13.7893 2.58579 13.4142C2.21071 13.0391 2 12.5304 2 12V2ZM4 1C3.73478 1 3.48043 1.10536 3.29289 1.29289C3.10536 1.48043 3 1.73478 3 2V12C3 12.2652 3.10536 12.5196 3.29289 12.7071C3.48043 12.8946 3.73478 13 4 13H11C11.2652 13 11.5196 12.8946 11.7071 12.7071C11.8946 12.5196 12 12.2652 12 12V6H8.5C8.10218 6 7.72064 5.84196 7.43934 5.56066C7.15804 5.27936 7 4.89782 7 4.5V1H4ZM8 1.207V4.5C8 4.63261 8.05268 4.75979 8.14645 4.85355C8.24021 4.94732 8.36739 5 8.5 5H11.793L8 1.207ZM0 3C0 2.73478 0.105357 2.48043 0.292893 2.29289C0.48043 2.10536 0.734784 2 1 2V12C1 12.7956 1.31607 13.5587 1.87868 14.1213C2.44129 14.6839 3.20435 15 4 15H11C11 15.2652 10.8946 15.5196 10.7071 15.7071C10.5196 15.8946 10.2652 16 10 16H3.94C2.89505 16 1.89289 15.5849 1.154 14.846C0.415106 14.1071 0 13.105 0 12.06V3Z"
					fill={strokeColor}
				/>
			</svg>
		</>
	)
}

export default CopyIcon
